import { Link } from "react-router-dom";
import { OVERDUE_ACTION, OVERDUE_BADGE, OVERDUE_SENTENCE, finishMatchPath, matchLine } from "../lib/plannedMatches";

const CHIP = { padding: "2px 8px", fontSize: 11, fontWeight: 600, borderRadius: "var(--nw-radius-pill)", whiteSpace: "nowrap" };

/**
 * Issue #1150 (D225 item 6) — the card a planned match becomes once its day
 * has passed: "This match has been and gone. Add how it went and it moves into
 * your record." Drawn in `PlanMatchAfter.dc.html` (round 10), mirroring the
 * training counterpart (`PlanTrainingOverdue`, #1041).
 *
 * One card, two homes: Plan's Coming up (`PlanComingUp`) and Record Match above
 * the season figures (`SeasonRecordScreen`). Each passes its own `testId`.
 * Add how it went is a LINK into the log flow's scorecard step
 * (`/performance?finish=<id>`, read by `hooks/useFinishPlannedMatch.js`), so
 * the harness registers nothing new. `from` is the screen the card is on; the
 * scorecard's Back returns there.
 *
 * The verb is navy and outlined, never gold: the screen's one gold stays
 * where it was (R-003).
 *
 * New in #1150 and imported only by those two new-look screens (D217).
 */
export default function PlannedMatchOverdueCard({ match, testId, from }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col"
      style={{ gap: 8, padding: 14, background: "var(--nw-surface)", border: "2px solid var(--nw-navy)", borderRadius: "var(--nw-radius-card)" }}
    >
      <div className="flex flex-wrap" style={{ gap: 6 }}>
        <span style={{ ...CHIP, background: "var(--nw-navy)", color: "var(--nw-surface)" }}>{OVERDUE_BADGE}</span>
        <span style={{ ...CHIP, background: "var(--nw-surface)", color: "var(--nw-ink-lede)", border: "1px solid var(--nw-line)" }}>Match</span>
      </div>
      <div className="nw-rowname">{`Match vs ${match.opponent || "TBD"}`}</div>
      <div className="nw-help">{matchLine(match)}</div>
      <div style={{ fontSize: 13, lineHeight: 1.5, color: "var(--nw-ink)" }}>{OVERDUE_SENTENCE}</div>
      <Link
        to={finishMatchPath(match.match_id)}
        state={{ from }}
        data-testid={`${testId}-add`}
        className="inline-flex items-center"
        style={{
          alignSelf: "flex-start",
          gap: 6,
          minHeight: "var(--nw-size-tap)",
          padding: "0 14px",
          background: "var(--nw-surface)",
          border: "1px solid var(--nw-line-strong)",
          borderRadius: "var(--nw-radius-control)",
          fontSize: 14,
          fontWeight: 600,
          color: "var(--nw-navy)",
          textDecoration: "none",
        }}
      >
        {OVERDUE_ACTION}
      </Link>
    </div>
  );
}
